import React, { useState, Fragment, useEffect } from 'react';
import clsx from 'clsx';
import voca from 'voca';
import { Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Avatar from '../../components/Avatar';
import Popover from '@material-ui/core/Popover';
import Button from '../../components/Buttons/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { doSelectPartners } from '../../redux/actionCreators/authentication';
import { doLogout } from '../../redux/thunks/authentication';
import {
  // selectCurrentUser,
  selectCurrentPartner,
  selectPartners,
} from '../../redux/selectors/authentication';
import TriangleSvg from '../../assets/svgComponent/triangle';

import LoadingBar from '../../components/LoadingBar';
import NotificationSnackbar from '../../components/NotificationSnackbar';
import MessageModal from '../../components/messageModal';
import MenuIcon from '@material-ui/icons/Menu';

import classname from 'classnames';
import style from './style.module.scss';
import { useMediaQuery } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import { MainListItems } from '../../helpers/listItems';
import FlexRow from '../../components/FlexBox/FlexRow';
import SButton from '../../components/SButton/SButton';
import SideBarNew from './Sidebar/SideBarNew';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    padding: 8,
    display: 'flex',
    justifyContent: 'space-between',
    transition: 'margin 0.3s',
    minHeight: 'auto',
    '@media (max-width: 768px)': {
      transition: 'margin 0.7s',
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  partnerContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  appBar: {
    backgroundColor: 'var(--state-w1)',
    zIndex: 100,
    boxShadow: 'none',
    color: '#cf480d',
    borderBottom: '1px solid var(--grey-300)'
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: '100%',
    backgroundColor: '#232e86',
    border: 'none',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    background: 'rgb(244, 244, 244)',
    marginLeft: '5rem',
    transition: 'margin 0.3s',
    '@media (max-width: 768px)': {
      marginLeft: '0',
      filter: 'blur(0px)',
      transition: 'margin 0.3s, filter 0.3s',
    },
  },
  contentOpened: {
    marginLeft: '17rem',
    '@media (max-width: 768px)': {
      marginLeft: '0',
      filter: 'blur(3px)',
      pointerEvents: 'none', // Blocks all mouse interactions (clicks, hovers)
      userSelect: 'none',
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  list: {
    width: '100%',
    maxWidth: 250,
    backgroundColor: theme.palette.background.paper,
  },
  partnerName: {
    color: '#1b1b1b',
    fontFamily: 'UrbanistSemiBold',
    fontSize: 14,
  },
  partner: {
    color: '#1b1b1b',
    fontFamily: 'UrbanistSemiBold',
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  partnerProfile: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  partnerDesc: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginRight: '0.5rem',
    width: 'max-content',
  },
  sectionContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  section: {
    marginBottom: '0.7rem',
  },
  parterRole: {
    color: '#1b1b1b',
    fontFamily: 'UrbanistSemiBold',
    fontSize: 10,
  },
  partnerHeader: {
    color: '#353f94',
    fontFamily: 'UrbanistSemiBold',
    fontSize: 12,
  },
  alignRight: {
    textAlign: 'right',
  },
  MuiPopover_paper: {
    borderRadius: '22px',
  },
}));

const DashboardLayout = ({ component: Component, ...rest }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  // const { width } = useWindowDimensions();
  const [open, setOpen] = useState(false);
  const { currentPartner, partners } = useSelector((state) => ({
    // currentUser: selectCurrentUser(state),
    currentPartner: selectCurrentPartner(state),
    partners: selectPartners(state),
  }));

  const [anchorEl, setAnchorEl] = useState(null);

  const [anhorLeft, setAnchorLeft] = useState(null);

  const handleLogout = () => {
    dispatch(doLogout());
    try {
      // Android (post a structured message, just like iOS)
      if ((window)?.FlutterLogout?.postMessage) {
        window.FlutterLogout.postMessage(
          "com.mrinq.smartaccess.refreshWebview"
        );
      } else {
        throw new Error("FlutterLogout bridge not found");
      }
    } catch (e) {
      console.log({ e })
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePartnerClick = (event) => {
    setAnchorLeft(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorLeft(null);
  };

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const isSmallScreen = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    if (isSmallScreen) {
      setOpen(false)
    }
  }, [isSmallScreen])

  return (
    <Route
      render={(props) => (
        <Fragment>
          <LoadingBar />
          <MessageModal />
          <div className={classes.root}>
            <CssBaseline />

            <AppBar
              className={clsx(classes.appBar)}
            >
              <Toolbar className={classes.toolbar} disableGutters style={{ marginLeft: isSmallScreen ? '0' : open ? '18rem' : '5rem', marginTop: (isSmallScreen && open) ? '-4.5rem' : '0' }}>
                <FlexRow flexWrap='nowrap' justifyContent='space-between'>
                  <FlexRow flexWrap='nowrap' width='fit-content' gap='0.5rem'>
                    {isSmallScreen && <IconButton
                      edge="start"
                      aria-label="open drawer"
                      onClick={handleDrawerOpen}
                      className={clsx(open && classes.menuButtonHidden)}
                    >
                      <MenuIcon fontSize="medium" className={style['grey-icon']} />
                    </IconButton>}
                    <div className={classes.partnerContainer} style={{ marginLeft: isSmallScreen ? '0' : '3rem' }} onClick={handlePartnerClick}>
                      <p style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '30vw' }} className={classes.partnerName}>
                        {!!currentPartner && currentPartner.partnerName}
                      </p>
                      {/* <ArrowDropDown fontSize="medium" className={style['grey-icon']} /> */}
                      <div className={style['icon']}>
                        <TriangleSvg className={style['svg']} />
                      </div>
                    </div>
                  </FlexRow>
                  <FlexRow flexWrap='nowrap' width='fit-content'>
                    <div>
                      <div className={clsx(style['profile'])} onClick={handleClick}>
                        <div className={classes.partnerProfile}>
                          <div className={classes.partnerDesc}>
                            <p style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: isSmallScreen ? '25vw' : '50vw' }} className={clsx(classes.partner, classes.alignRight)}>
                              {!!currentPartner && currentPartner?.name}
                            </p>
                            <p className={clsx(classes.parterRole, classes.alignRight)}>
                              {!!currentPartner &&
                                voca
                                  .chain(currentPartner?.role?.name)
                                  .replaceAll('_', ' ')
                                  .upperCase()
                                  .value()}
                            </p>
                          </div>
                        </div>
                        <Avatar
                          size="xsmall"
                          name={!!currentPartner && currentPartner?.name?.charAt(0)}
                        />
                      </div>

                      <Popover
                        id="simple-menu"
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                        classes={{ paper: style['popover-root'] }}
                      >
                        <div className={style['popover']}>
                          <div className={clsx(classes.sectionContainer)}>
                            <div onClick={handleClose} className={style['popover-content-pic']}>
                              <Avatar
                                size="xsmall"
                                name={!!currentPartner && currentPartner?.name?.charAt(0)}
                              />
                            </div>
                            <div style={{ width: '85%' }}>
                              <p style={{ width: '90%' }} className={clsx(classes.partner)}>
                                {!!currentPartner && currentPartner?.name}
                              </p>
                              <p className={clsx(classes.parterRole)}>
                                {!!currentPartner &&
                                  voca
                                    .chain(currentPartner?.role?.name)
                                    .replaceAll('_', ' ')
                                    .upperCase()
                                    .value()}
                              </p>
                            </div>
                          </div>
                          <div style={{ marginLeft: '1rem' }}>
                            <div className={clsx(classes.section)}>
                              <p className={clsx(classes.partnerHeader)}>Partner Name</p>
                              <p style={{ width: '90%' }} className={clsx(classes.partner)}>
                                {!!currentPartner && currentPartner?.partnerName}
                              </p>
                            </div>

                            <div className={clsx(classes.section)}>
                              <p className={clsx(classes.partnerHeader)}>Partner Email</p>
                              <p style={{ width: '90%' }} className={clsx(classes.parterRole)}>
                                {!!currentPartner && currentPartner?.email}
                              </p>
                            </div>
                          </div>
                          <div className={style['popover-content-button']}>
                            <SButton fullWidth onClick={handleLogout} color={"error"}>Sign Out</SButton>
                          </div>
                          <div className="spacer__0-5" />
                        </div>
                      </Popover>

                      <Popover
                        id="simple-menu"
                        open={Boolean(anhorLeft)}
                        anchorEl={anhorLeft}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                        classes={{ paper: style['popover-root'] }}
                      >
                        <div className={classname(style['popover'], 'pd-2')}>
                          <div className={style['popover-content-partner']}>
                            <p className={clsx(classes.partner)}>Partners</p>
                          </div>

                          <List component="nav" className={classes.list} aria-label="partners">
                            {!!partners &&
                              partners.map((partner, idx) => (
                                <Fragment key={idx}>
                                  <ListItem
                                    classes={{ root: style['list-item'] }}
                                    button
                                    disabled={partner.partnerName === currentPartner.partnerName}
                                    onClick={() => {
                                      handleClose();
                                      dispatch(doSelectPartners({ partnerId: partner.partnerId }));
                                    }}
                                  >
                                    <ListItemText
                                      primary={`${partner.partnerName}`}
                                      classes={{ root: style['sub-header'] }}
                                    />
                                  </ListItem>
                                  {/* <Divider /> */}
                                </Fragment>
                              ))}
                          </List>
                        </div>
                      </Popover>
                    </div>
                  </FlexRow>
                </FlexRow>


              </Toolbar>
            </AppBar>

            <SideBarNew
              sidebarOpened={open}
              changeSidebarState={(state) => { setOpen(state); }}
            />

            <main className={clsx(classes.content, open && classes.contentOpened)} id="scrollable-win">
              <div className={classes.appBarSpacer} />
              <Box py={2} px={3}>
                <Component {...props} />
              </Box>
            </main>
          </div>
          <NotificationSnackbar />
        </Fragment>
      )}
      {...rest}
    />
  );
};

export default DashboardLayout;
